import jQuery from "jquery";
import {
    scrollToSection
} from "../../utilities/helpers";
import Flickity from "flickity";
import {
    mediaOrientation
} from "../../utilities/mediaorientation";
import { runMediaOrientation, setStatus, updateStatus } from "../../utilities/helpers";

export function initBlocks(container) {

    var $ = $ || jQuery;

    // text wysiwyg editor
    var editorBlock = container.querySelectorAll('.block--text'),
        // video
        videoBlock = container.querySelectorAll('.block--video'),
        // publication
        publicationBlock = container.querySelectorAll('.block--publicaton') && container.querySelectorAll('.group--publication .block--publication'),
        // groupPublicationBlock = container.querySelectorAll('.group--publication');
        referencesBlock = container.querySelectorAll('.block--references'),
        galleryBlock = container.querySelectorAll('.block--gallery');

 
    if (editorBlock.length > 0) {

        // console.log('.block--text exists', editorBlock);

        editorBlock.forEach(function (block) {

            // console.log('EACH .block--text exists', block);
            // this approach become flawed if we start using the editor in "small" instances, and want to keep scroll snapping
            // if this happens; review approach and create better solution

            // var data = "no-scroll-snap",
            // initiator = "has-editor";

            // assignScrollSnapping(data, initiator);
        });

    } // 

    if (videoBlock.length > 0) {

        // console.log('.block--video exists', videoBlock);

        videoBlock.forEach(function (block) {

            // console.log('EACH .block--video exists', block);

        });

    } // 

    if (publicationBlock.length > 0) {

        // the above woudld be looking for the block--publication in the group--publication
// AND again - so this would fire twice.
        // console.log('.block--publication exists', publicationBlock);
        // console.log('IS the adone jquery error causing my barba to crash - meaning ensure to have jquery running?', publicationBlock);

        if (typeof PDFViewerApplication !== 'undefined') {
            // review if this heplps?

            // console.log('PDFViewerApplication exists', PDFViewerApplication);
            PDFViewerApplication.initialize();
        }
   
   
       
 


        // console.log('PDFViewerApplication exists', PDFViewerApplication);

        // we need to extract "embedMode" or some defining factor in going foward with my js work
        // I'm not sure classes are sufficient to define the different states of the block
        // i.e lightbox (button), inline (classes), sizedcontainer (same classe?) etc

        publicationBlock.forEach(function (block) {

        //  console.log('EACH .block--publication exists', block);
            if (block.closest('.wp-block-group').classList.contains("group--publication") == true) {

                // console.log("publicationBlock.closest('.group--publication') exists", block.closest('.group--publication'));

                //group
                var groupPublicationBlock = block.closest('.group--publication'),
                    // adobe block
                    adobeBlock = groupPublicationBlock.querySelector('.wp-block-pdf-embed-plugin-for-wp-embedded-pdf'), //adobe block
                    adobeBlockLink = adobeBlock.querySelector('button'), //adobe block = lightbox
                    pdfEmbedType = block.getAttribute('data-pdf-embed-type'),
                    // I forget the significance of this - should it be iframe instead - or why are we looking for a (non existing) button
                    /* what we need is to ensure all the links in the publication block are clickable and trigger the adobeBlockLink click event 
                    // but it does exist in some instances:
                    https://saxoncbe.local/resources/the-jct-povey-lecture-vision-for-the-industry/
                    // meaning its probably a case of how the block is configured in the editor
                    // and that I'm not catering for all scenarios?

                    */
// instead of looking for a button - let look for the data attribute set by admin js.


                    publicationExternalLink = groupPublicationBlock.querySelectorAll('.publication__item-link button'),
                //    this adobeBlockLink exist if its a lightbox?

                    //what are we looking for or checking against?

                    // console.log("adobeBlock", adobeBlock);
                    // console.log("adobeBlockLink", adobeBlockLink);
                    //link
                    publicationBlockLink = groupPublicationBlock.querySelectorAll('.publication__item-read-link button'); // ensure we can only have 1 of these per details - in ACF settings?
                   
                   
                    // console.log("adobeBlock", adobeBlock);
                    // console.log("pdfEmbedType", pdfEmbedType);
                    // console.log("publicationBlockLink", publicationBlockLink);
                    // console.log("adobeBlockLink", adobeBlockLink);

                if (pdfEmbedType){
                    groupPublicationBlock.setAttribute('data-pdf-embed-type', pdfEmbedType); // set the data attribute on the group
                    //using the same attribute atm - should be okay for css. reivew if not.
                }

                if (adobeBlockLink !== null) {

                  //   console.log("adobeBlockLink exists", adobeBlockLink);
                    //click event on publicationBlockLink
                    publicationBlockLink.forEach(function (link) {
                       // console.log("publicationBlockLink exists", link);
                        link.addEventListener('click', function (e) {
                       //  console.log('publicationBlockLink click', link);
                            e.preventDefault();
                        //  console.log('publicationBlockLink click', link);
                            adobeBlockLink.click();
                        });
                    });
                }
                // } else if (adobeBlocklink !== null) {
                //     // console.log("adobeBlockLink does not exist -i.e not a lightbox", adobeBlockLink);
                //     // if its not a lightbox, we still want to keep other butotn functionality?
                //     // i.e readlink


                //     console.log("adobeBlockInline exists", adobeBlockInline);

                //     // ViewSDK_parentRelativeHeight
            
                // }

                if (publicationExternalLink !== null) {
                    // I guess this link doesnt need any js 
                    // so leave emptly - placeholder for future use if needed
                    // console.log("publicationExternalLlink exists", publicationExternalLink);
                    //click event on publicationBlockLink
                    // publicationExternalLlink.forEach(function (link) {
                    //     console.log("publicationExternalLlink exists", link);
                        
                    // });

                }


            } else
            // if this publication exist without a "group--publication"
            {
// 
                console.log(" if this publication exist without a group--publication TO DOD - finsih this  figure out other scenear etcios", publicationBlock);

                //to do finish this without teh group--publication stuff - so would be .. ?

                // console.log("publicationBlock.closest('.group--publication') does not exist", publicationBlock.closest('.group--publication'));

                // var publicationBlockLink = publicationBlock.querySelectorAll('.block--publication__read-link button'); // ensure we can only have 1 of these per details - in ACF settings?

                // console.log("publicationBlockLink", publicationBlockLink);

                // //click event on publicationBlockLink
                // publicationBlockLink.forEach(function (link) {
                //     link.addEventListener('click', function (e) {

                //         console.log('publicationBlockLink click', link);

                //         e.preventDefault();
                //         console.log('publicationBlockLink click', link);
                //         link.closest('.block--publication').querySelector('button').click();
                //     });
                // });

            }

        });

        // TOI DOI -= tidy up this code also I should move the bulk of this js out of this file; create seperate fucntion & import its use for each block etc.

    } //

    if (referencesBlock.length > 0) {

        var blockRefLinks = container.querySelectorAll('.reference__inline-item'); // alt eh linline item

//  console.log('.reference__inline-item items exists',blockRefLinks);

        referencesBlock.forEach(function (block) {

        // console.log('EACH .block--references exists', block);



            var references = block.querySelectorAll('.references__item');


        //    console.log("references",references);

            //example of tbe href link markup - 
            // #inline_ref_4
            // #ref_4

            references.forEach(function (reference) {

                // console.log('EACH .block--references exists', reference);

                var referenceItem = reference.querySelector('.references__item-link');

                var refLink = referenceItem.getAttribute('data-link-id'); //data-link-id is a number number id="ref_{{ count }}" -- review if clean aproach - not conflicitong?
                var refLinkID = "ref_" + refLink + "";
                var refInlineID = "inline_ref_" + refLink + "";
                var referenceItemInline = container.querySelector("#" + refInlineID + "");

                // var inlineItem = block.querySelectorAll('.reference__inline-item');
                // var inlineLink = block.querySelectorAll('.reference__inline-item');
                //  console.log("refLinkID", refLinkID);
                //  console.log("refInlineID", refInlineID);
                //  console.log("referenceItemInline", referenceItemInline);

                //click event on referencesBlockLink

                // need scroll to click event on href link

                referenceItem.addEventListener('click', function (e) {
                    e.preventDefault();
                    // console.log('referenceItem click', referenceItem);
                    // console.log('referenceItem click', referenceItem);

                    //scroll to the associated inline item
                    // scrollToSection(refLinkID, container);
                    scrollToSection(refInlineID, container);


                });

                referenceItemInline.addEventListener('click', function (e) {
                    e.preventDefault();
                    // console.log('referenceItemInline click', referenceItemInline);

                    //scroll to the associated inline item
                    //  scrollToSection(refInlineID, container);
                    scrollToSection(refLinkID, container);
                });

                // or do I just add the reverse click function here?
            });


            // we need to find the correlating links in the article; which will be container in other blocks

        });
        //delete this
        //    // for each inline item
        //    blockRefLinks.forEach(function (blockRefLink) {
        //            // I also need to have the scrollto the other way - i.e each inline item should scroll to the associated referencebllock item

        //             console.log('EACH .reference__inline-item exists', blockRefLink);



        //             blockRefLink.addEventListener('click', function (e) {
        //                 e.preventDefault();
        //                 console.log('inlineItemLink click', inlineItemLink);
        //                 // console.log('referenceItem click', referenceItem);
        //                 var refLinkID = blockRefLink.getAttribute('data-link-id'); //id="ref_{{ count }}" -- review if clean aproach - not conflicitong?
        //                 // inlineLinkID = referencesBlock.querySelector('.references__item-link');
        //                 //scroll to the associated inline item
        //                 scrollToSection(inlineLinkID, container);
        //             });
        //         });

    } //    

    if (galleryBlock.length > 0) {
        // console.log('galleryBlock.length > 0', galleryBlock);

        galleryBlock.forEach(function (block) {
            // console.log('EACH .block--gallery exists', block);

            var gallery = block.querySelectorAll('.--gallery');
            // console.log("gallery", gallery);

            gallery.forEach(function (galleryItem) {
                // console.log('EACH .block--gallery exists', galleryItem);

                // Flickity options
                var flickityoptions = {
                    imagesLoaded: true,
                    setGallerySize: false,
                    pageDots: false,
                    freeScroll: false,
                    wrapAround: true,
                    prevNextButtons: false,
                    cellAlign: 'left'
                };

                // Cache DOM elements
                var thisslideshow = galleryItem.querySelector(".slideshow__carousel"),
                    // thisslideshowcounter = galleryItem.querySelector('.slideshow__counter'),
                    navPrevious = galleryItem.querySelector('.slideshow__navigation-left'),
                    navDrag = thisslideshow,
                    navNext = galleryItem.querySelector('.slideshow__navigation-right');

                // Check if the necessary elements exist
                // if (!thisslideshow || !thisslideshowcounter || !navPrevious || !navNext) {
                if (!thisslideshow || !navPrevious || !navNext) {
                    console.error('One or more required elements are missing in the galleryItem:', galleryItem);
                    return;
                }

                // console.log("Initializing Flickity for", thisslideshow);

                // Initialize Flickity
                var flkty = new Flickity(thisslideshow, flickityoptions);
                // console.log("Flickity instance:", flkty);

                // Use the 'settle' event as a workaround for the 'ready' event
                flkty.on('settle', function () {
                    // console.log("flkty on settle event");

                    var imageSlides = thisslideshow.querySelectorAll("[data-slide-type='image'] .image__wrap");
                    flkty.focus();
                     runMediaOrientation(imageSlides, thisslideshow);
                    flkty.resize();
                    runMediaOrientation(imageSlides, thisslideshow);
                    // setStatus(flkty, thisslideshowcounter);

                    navPrevious.addEventListener('click', function () {
                        flkty.previous()//.focus();
                        flkty.focus();
                    });

                    navNext.addEventListener('click', function () {
                        flkty.next()//.focus();
                        flkty.focus();
                    });

                    flkty.on('change', function () {
                        runMediaOrientation(imageSlides, thisslideshow);
                        // updateStatus(flkty, thisslideshowcounter);
                    });

                    window.addEventListener('resize', function () {
                        flkty.resize();
                        runMediaOrientation(imageSlides, thisslideshow);
                    });
                });

                // Manually trigger the 'settle' event if Flickity is already settled
                if (flkty.isReady) {
                    flkty.dispatchEvent(new Event('settle'));
                }
            });
        });
    }

    

    // gallery block end 

    console.log("end of initBlocks");

}